export default __webpack_public_path__ + "static/media/download.c2f28249.svg";